import { render, staticRenderFns } from "./testInstitutionsDetail.vue?vue&type=template&id=0b41df22&scoped=true"
import script from "./testInstitutionsDetail.vue?vue&type=script&lang=js"
export * from "./testInstitutionsDetail.vue?vue&type=script&lang=js"
import style0 from "./testInstitutionsDetail.vue?vue&type=style&index=0&id=0b41df22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b41df22",
  null
  
)

export default component.exports